module.exports = __webpack_public_path__ + "img/standardYSYL.809dc06c.png";